<template>
    <div class="breadcrumb clearfix mb-2">
        <!-- <div class="float-left">
            {{$t($route.meta.title)}}
        </div> -->
        <el-breadcrumb separator="/" class="float-right">
            <el-breadcrumb-item
                v-for="(item, index) in breadList"
                :to="{
                    path:item.path,
                    query:item.query
                }"
                :replace="true"
                :key="index"
            >{{$t(item.meta.title)}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    data() {
        return {
            breadList: [],
        };
    },
    watch: {
        $route: {
            handler(route) {
                let allList = route.matched.filter((item) => {
                    if (item.meta && item.meta.title) {
                        if (item.name == "home") {
                            item.path = "/home";
                        }
                        if(route.params.readId){
                             item.path = item.path.replace(/(?<=readList\/).*?(?=\/)/i,route.params.readId)
                        }
                        if(route.params.taskId){
                             item.path = item.path.replace(/(?<=readTastList\/).*?(?=\/)/i,route.params.tastId)
                        }
                        item.query = item.meta.query
                        // else {
                        //     item.path = "";
                        // }
                        return true;
                    }
                });
                // if (allList[0].path !== "/home") {
                //     allList.unshift({
                //         path: "/home",
                //         meta: { title: "tIndex" },
                //     });
                // }
                this.breadList = allList;
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
    margin-bottom: 20px;
}

.float-left{float:left;}
.float-right{float:right;}
.clearfix:after{content:'';display:block; clear:both; text-indent:-99999px;}

.mb-2 {margin-bottom:20px;}
</style>
